module.exports = __webpack_public_path__ + "img/kplay_esport.88fb0823.jpeg";